<template>
  <div class="favorability-toggle">
    <div class="favorability-toggle__switch">
      <SwitchButton
        :value="isMoreFavorable"
        :show-title="false"
        label=""
        container-width="auto"
        :disabled="disabled"
        :aria-label="switchAriaLabel"
        @onChange="onChange"
      />
    </div>
    <div class="favorability-toggle__text">
      <div class="favorability-toggle__heading">
        <span class="favorability-toggle__icon" aria-hidden="true">
          <FavorabilityIcon :less_is_better="!isMoreFavorable" :size="24" color="Grey" />
        </span>
        <span class="favorability-toggle__label">{{ copy.label }}</span>
      </div>
      <span class="favorability-toggle__helper">{{ copy.helper }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import SwitchButton from "@components/SwitchButton/SwitchButton.vue";
import FavorabilityIcon from "@components/FavorabilityIcon/FavorabilityIcon.vue";
import {
  FAVORABILITY_COPY,
  FAVORABILITY_VALUES,
  LESS_IS_FAVORABLE,
  MORE_IS_FAVORABLE,
} from "@components/constants/favorability";

const props = defineProps({
  modelValue: {
    type: String,
    default: MORE_IS_FAVORABLE,
    validator: (value) => FAVORABILITY_VALUES.includes(value),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  ariaLabel: {
    type: String,
    default: "Favorability",
  },
});

const emit = defineEmits(["update:modelValue"]);

const isMoreFavorable = computed(() => props.modelValue !== LESS_IS_FAVORABLE);
const copy = computed(
  () => FAVORABILITY_COPY[isMoreFavorable.value ? MORE_IS_FAVORABLE : LESS_IS_FAVORABLE]
);
const switchAriaLabel = computed(() => `${props.ariaLabel}: ${copy.value.label}`);

const onChange = ({ value }) => {
  if (props.disabled) return;
  emit("update:modelValue", value ? MORE_IS_FAVORABLE : LESS_IS_FAVORABLE);
};
</script>

<style scoped>
.favorability-toggle {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background-color: #ffffff;
}

.favorability-toggle__switch {
  flex-shrink: 0;
}

.favorability-toggle__switch :deep(.editing-switch-container) {
  left: 0;
  width: auto;
  justify-content: flex-start;
}

.favorability-toggle__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.favorability-toggle__heading {
  display: flex;
  align-items: center;
  gap: 7px;
  height: 24px;
}

.favorability-toggle__icon {
  display: inline-flex;
}

.favorability-toggle__label {
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #344054;
}

.favorability-toggle__helper {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #475467;
}
</style>
